import React from "react";

import { FormControl, FormLabel } from "@portex-pro/ui-components";
import { DriverPreference } from "api/types/generated-types";
import { mapDriverPreferenceToCopy } from "pages/shipper/utils/mapDriverPreferenceToCopy";
import { useTranslation } from "react-i18next";

import { ButtonGroup, TabOption } from "../../_components";

interface DriverPreferenceViewProps {
  driverPreference: DriverPreference;
  onSelectDriverPreference: (preference: DriverPreference) => void;
}

const driverPreferenceOptions: DriverPreference[] = [
  DriverPreference.None,
  DriverPreference.Solo,
  DriverPreference.Team,
];

const DriverPreferenceView: React.FC<DriverPreferenceViewProps> = (props) => {
  const { t } = useTranslation(["shipper"]);
  const { driverPreference, onSelectDriverPreference } = props;

  const options: TabOption<DriverPreference>[] = driverPreferenceOptions.map((preference) => ({
    value: preference,
    label: mapDriverPreferenceToCopy[preference],
  }));

  return (
    <FormControl margin="dense" fullWidth>
      <FormLabel>{t("shipper:driverPreference")}</FormLabel>
      <ButtonGroup
        options={options}
        selected={driverPreference}
        onSelect={onSelectDriverPreference}
        hasError={!driverPreference}
      />
    </FormControl>
  );
};

export default DriverPreferenceView;
